export const getUserAbbreviation = (
    firstName: string | undefined | null,
    lastName: string | undefined | null,
    displayName: string
) => {
    if (firstName && lastName) {
        return (firstName[0] + lastName[0]).toUpperCase();
    } else {
        if (!displayName) {
            return '';
        }

        const words = displayName.split(' ').filter((x) => x.length > 0);

        if (words.length === 0) {
            return '';
        }

        return (words[0][0] + (words.length > 1 ? words[1][0] : words[0].length > 1 ? words[0][1] : '')).toUpperCase();
    }
};
